// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__3RS6f","banner-info":"styles_banner-info__2gq0k","banner-warning":"styles_banner-warning__11ikb","banner-danger":"styles_banner-danger__f77Nr"};